<script>
import pageError from '@/assets/images/404.svg'
import networkError from '@/assets/images/500.svg'
import noPermission from '@/assets/images/403.svg'

export default {
  name: 'Error',
  props: {
    type: {
      type: String,
      default: '404',
      validator: function(value) {
        return ['404', '500', '403'].indexOf(value) !== -1
      }
    },
    showBtn: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    errorMap: function() {
      return {
        '404': {
          url: pageError,
          message: '抱歉，访问的页面不存在',
          buttonText: '返回首页'
        },
        '500': {
          url: networkError,
          message: '抱歉，服务器开小差了',
          buttonText: '返回首页'
        },
        '403': {
          url: noPermission,
          message: '抱歉，您没有访问权限',
          buttonText: '返回首页'
        }
      }
    }
  },
  methods: {
    btnClick: function() {
      this.$emit('error-click', this.type)
    }
  }
}
</script>

<template>
  <div class="error-page">
    <div class="error-page__content">
      <img :src="errorMap[type].url" alt="" width="350">
      <div class="error-page__message">{{ errorMap[type].message }}</div>
      <div v-if="showBtn" class="error-page__action">
        <el-button type="primary" @click="btnClick">{{ errorMap[type].buttonText }}</el-button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.error-page {
  display: flex;
  justify-content: center;
}

.error-page__content {
  text-align: center;
}

.error-page__message {
  font-size: 14px;
  color: #909399;
}

.error-page__action {
  margin-top: 20px;
}
</style>
